export default function MuiSelect(theme: any) {
  return {
    MuiSelect: {
      variants: [
        {
          props: { variant: "outlined" },
          style: {},
        },
      ],
      styleOverrides: {
        root: {
          color: "white",
          borderRadius: "32px",

          "& .MuiSelect-icon": {
            color: "transparent",
            right: "20px",
          },
          "&:hover": {
            backgroundColor: "transparent",
          },
          "&.MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.grey[500],
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.grey[500],
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.grey[0],
          },
          "& .MuiSelect-select-MuiInputBase": {
            padding: "0px 21px",
          },
        },
      },
    },
  };
}
